import { put, takeLatest } from 'redux-saga/effects'
import { sagaActions } from '@/redux/sagaActions'
import { callAPI, HttpMethod } from '.'
import { FixTypeLater } from 'react-redux'
import { setPlayerToken } from '@/redux/reducers/userReducer'
import {
  TOKEN_BALANCE_FRESH_STORAGE_KEY,
  TOKEN_BALANCE_FRESH_FALSE,
} from '@/constants/storage'

import { toast } from 'react-hot-toast'
import { captureException } from '@sentry/react'

import { TESTING_DISABLE_BALANCE_FETCH } from '@/constants/testing'

const API_FETCH_USER_BALANCE = `${import.meta.env.VITE_HOST}/api/v1/seamless/fetchUserBalance`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function* fetchUserBalance(action: FixTypeLater): FixTypeLater {
  if (TESTING_DISABLE_BALANCE_FETCH) {
    console.log('Skipping balance fetch due to TESTING_DISABLE_BALANCE_FETCH')
    return
  }
  console.log('Saga called: fetchUserBalance')
  // Mark token-based balance as stale as we're fetching fresh balance
  localStorage.setItem(
    TOKEN_BALANCE_FRESH_STORAGE_KEY,
    TOKEN_BALANCE_FRESH_FALSE,
  )
  yield put(
    setPlayerToken({
      isUpdating: true,
    }),
  )

  try {
    const result: FixTypeLater = yield callAPI({
      url: API_FETCH_USER_BALANCE,
      method: HttpMethod.POST,
      data: {},
    })
    // console.log(result)
    yield put(
      setPlayerToken({
        userBalance: result?.data?.data?.balance,
        isUpdating: false,
      }),
    )
  } catch (e: unknown) {
    toast.error('Could not update balance')

    captureException(e)

    yield put(
      setPlayerToken({
        isUpdating: false,
      }),
    )
  }
}

export function* watchUser() {
  // yield takeLatest<FixTypeLater>(sagaActions.POST_AUTH_PLAYER, authUser)
  yield takeLatest<FixTypeLater>(
    sagaActions.USER_FETCH_BALANCE,
    fetchUserBalance,
  )
}
